export const SET_PRE_CUSTOMER_REGISTRATION_LOADING = (state, action) => {
  const { loading } = action.payload;
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        loading,
      }
    }
  };
};

export const SET_PRE_CUSTOMER_REGISTRATION_DATA = (state, action) => {
  const { data } = action.payload;
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        data,
      }
    }
  };
};

export const SET_PRE_CUSTOMER_REGISTRATION_SEARCH_TERM = (state, action) => {
  const { searchTerm } = action.payload;
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        searchTerm,
      }
    }
  };
};

export const ADD_PRE_CUSTOMER_REGISTRATION = (state, action) => {
  const { item } = action.payload;
  const currentData = state.medicalRecord.preCustomerRegistration.data || [];
  
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        data: [...currentData, item],
      }
    }
  };
};

export const UPDATE_PRE_CUSTOMER_REGISTRATION = (state, action) => {
  const { item } = action.payload;
  const currentData = state.medicalRecord.preCustomerRegistration.data || [];
  
  const updatedData = currentData.map(existingItem => 
    existingItem.id === item.id ? item : existingItem
  );
  
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        data: updatedData,
      }
    }
  };
};

export const DELETE_PRE_CUSTOMER_REGISTRATION = (state, action) => {
  const { id } = action.payload;
  const currentData = state.medicalRecord.preCustomerRegistration.data || [];
  
  const filteredData = currentData.filter(item => item.id !== id);
  
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        data: filteredData,
      }
    }
  };
}; 

export const GET_SECTIONS_MEDICAL_RECORDS_PRE_CUSTOMER_REGISTRATION_CONFIG_FETCH_REQUEST = (state, action) => {
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        loading: true,
      }
    }
  };
};

export const GET_SECTIONS_MEDICAL_RECORDS_PRE_CUSTOMER_REGISTRATION_CONFIG_FETCH_SUCCESS = (state, action) => {
  const { sectionsModels } = action.payload;
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        sectionsModels,
      }
    }
  };
};

export const GET_SECTIONS_MEDICAL_RECORDS_PRE_CUSTOMER_REGISTRATION_CONFIG_FETCH_ERROR = (state, action) => {
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        loading: false,
        error: action.payload.error,
      }
    }
  };
};

export const SET_FORM_MODELS_PRE_CUSTOMER_REGISTRATION = (state, action) => {
  const { formModels } = action.payload;
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        formModels,
      }
    }
  };
};

export const ADD_PRE_CUSTOMER_REGISTRATION_REQUEST = (state, action) => {
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        fetching: {
          ...state.medicalRecord.preCustomerRegistration.fetching,
          addPreCustomerRegistration: true,
        },
      }
    }
  };
};

export const ADD_PRE_CUSTOMER_REGISTRATION_SUCCESS = (state, action) => {

  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        fetching: {
          ...state.medicalRecord.preCustomerRegistration.fetching,
          addPreCustomerRegistration: false,
        },
      }
    }
  };
};

export const ADD_PRE_CUSTOMER_REGISTRATION_ERROR = (state, action) => { 
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        fetching: {
          ...state.medicalRecord.preCustomerRegistration.fetching,
          addPreCustomerRegistration: false,
        },
      }
    }
  };
};

export const GET_PRE_CUSTOMER_REGISTRATION_REQUEST = (state, action) => {
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        fetching: {
          ...state.medicalRecord.preCustomerRegistration.fetching,
          getPreCustomerRegistration: true,
        },
      }
    }
  };
};

export const GET_PRE_CUSTOMER_REGISTRATION_SUCCESS = (state, action) => {
  const { preRegistrationLinks } = action.payload;
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        fetching: {
          ...state.medicalRecord.preCustomerRegistration.fetching,
          getPreCustomerRegistration: false,
        },
        listPreCustomerRegistration: preRegistrationLinks,
      }
    }
  };
};

export const GET_PRE_CUSTOMER_REGISTRATION_ERROR = (state, action) => {
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        fetching: {
          ...state.medicalRecord.preCustomerRegistration.fetching,
          getPreCustomerRegistration: false,
        },
      }
      }
    };
  };

export const UPDATE_PRE_CUSTOMER_REGISTRATION_REQUEST = (state, action) => {
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        fetching: {
          ...state.medicalRecord.preCustomerRegistration.fetching,
          updatePreCustomerRegistration: true,
        },
      }
    }
  };
};

export const UPDATE_PRE_CUSTOMER_REGISTRATION_SUCCESS = (state, action) => {
  const { data } = action.payload;
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        fetching: {
          ...state.medicalRecord.preCustomerRegistration.fetching,  
          updatePreCustomerRegistration: false,
        },
      }
    }
  };
};

export const UPDATE_PRE_CUSTOMER_REGISTRATION_ERROR = (state, action) => {
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,   
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        fetching: {
          ...state.medicalRecord.preCustomerRegistration.fetching,
          updatePreCustomerRegistration: false,
        },
      }
    }
  };
};

export const DELETE_PRE_CUSTOMER_REGISTRATION_REQUEST = (state, action) => {
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        fetching: {
          ...state.medicalRecord.preCustomerRegistration.fetching,
          deletePreCustomerRegistration: true,
        },
      }
    }
  };
};

export const DELETE_PRE_CUSTOMER_REGISTRATION_SUCCESS = (state, action) => {
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        fetching: {
          ...state.medicalRecord.preCustomerRegistration.fetching,
          deletePreCustomerRegistration: false,
        },
      }
    }
  };
};

export const DELETE_PRE_CUSTOMER_REGISTRATION_ERROR = (state, action) => {
  return {
    ...state,
    medicalRecord: {
      ...state.medicalRecord,
      preCustomerRegistration: {
        ...state.medicalRecord.preCustomerRegistration,
        fetching: {
          ...state.medicalRecord.preCustomerRegistration.fetching,
          deletePreCustomerRegistration: false,
        },
      }
    }
  };
};